import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import type { ComponentProps } from "react";
import { cn } from "../../lib/cn";

function TooltipProvider(props: ComponentProps<typeof TooltipPrimitive.Provider>) {
  return <TooltipPrimitive.Provider {...props} />;
}

function Tooltip(props: ComponentProps<typeof TooltipPrimitive.Root>) {
  return <TooltipPrimitive.Root {...props} />;
}

function TooltipTrigger(props: ComponentProps<typeof TooltipPrimitive.Trigger>) {
  return <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />;
}

function TooltipContent({
  children,
  className,
  ...props
}: ComponentProps<typeof TooltipPrimitive.Content>) {
  return (
    <TooltipPrimitive.Portal>
      {/* Above every other layer (chrome 30, modal 50, palette 70, dropdown and
          drawer 100, toast 110). A tooltip annotates a control that may itself
          live in any of those, and portaled content with `z-auto` is painted
          under the sticky top bar. */}
      <TooltipPrimitive.Content
        className={cn(
          "z-[120] max-w-[calc(var(--space-16)*4)] break-words rounded-[var(--radius-sm)] bg-[var(--color-text)] px-[var(--space-2)] py-[var(--space-1)] text-[length:var(--type-meta)] [font-weight:var(--type-weight-medium)] text-[var(--color-surface)] shadow-[var(--shadow-hover)]",
          className,
        )}
        data-slot="tooltip-content"
        {...props}
      >
        {children}
        <TooltipPrimitive.Arrow className="h-[var(--space-1)] w-[var(--space-3)] fill-[var(--color-text)]" />
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  );
}

export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger };
